export class TimeoutWarningModalConfig {
  title?: string = 'Extend Your Session';
  body?: string =
    'Your current session will expire in ${countdown}. You can extend the session or logout.';
  imgLink?: string = '';

  constructor(options: TimeoutWarningModalConfig = {}) {
    Object.assign(this, options || {});
  }
}
